export const DEFAULT_PAGINATION_LIMIT = 10000;
export const SMALL_BATCH_PAGINATION_LIMIT = 1000;
